/** @jsx jsx */
import { jsx, Box, useColorMode } from 'theme-ui'
import { motion } from 'framer-motion'
import { useMapboxContext } from '../useMapboxContext'

const Controls = React.forwardRef(({ children, ...props }, ref) => {
  return (
    <Box
      ref={ref}
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        right: 12,
        bottom: 12,
      }}
      {...props}
    >
      {children}
    </Box>
  )
})

export { Controls }
